import React, { createContext, useContext, useState, useEffect, useCallback, Fragment } from "react"
import { useParams } from "react-router-dom"
import { useAppCtx } from "lib/state"
import { appTools, cn, queryTools, runConditionalLogic } from "lib/utils"
import { evaluateConditionalObj } from "lib/utils/conditionals"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent } from "./utils"

function RenderedStatementElement({ idx, mode, elemtype, contentObj, renderPkg }:{ idx:number; mode:string; elemtype:string; contentObj:any; renderPkg:any }) {
  const elemStyle = useRenderStyling("block w-full ml-4 pr-4", "styleObj")

  function ElementWrapperTag({ elemtype, content, ...rest }:{ elemtype:string; content:any }) {
  if( elemtype === "compelling_evidence" ){
    return (
      <div style={{ display: "flex", flexDirection: "row", width: "100%", marginBottom: ".5rem" }}>
        <span style={{ paddingRight: "8px" }}>{ idx+1 }.</span>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    )
  } else {
    return <div {...rest} dangerouslySetInnerHTML={{ __html: content }} />
  }
}

  return (
    <ElementWrapperTag elemtype={elemtype} content={contentObj.content} className="mm-statement" {...elemStyle}  />

  )
}

function StatementsWrapperTag({ elemtype, children }:{ elemtype:string; children:any }) {
  if( elemtype === "compelling_evidence" ){
    return <div style={{ paddingLeft: "1.5rem" }}>{children}</div>
  } else {
    return <div>{children}</div>
  }
}


const StatementsRenderInternal = ({ 
  mode="preview",
  elemtype="opening_statements", 
  renderPkg, 
  showTests=false 
}:{ 
  mode:string;
  elemtype:string; 
  renderPkg:any;
  showTests?:boolean 
}) => { 
 
  const { dspid } = useParams<{ dspid?: string }>()

  const [ statementsReady, setStatementsReady ] = useState<boolean>(false)
  const [ contentToDisplay, setContentToDisplay ] = useState<any[]>([])
  const [ conditionalReport, setConditionalReport ] = useState<any>(null)
  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })

  const evaluateAllStatements = (statements:any) => {
    // const statements = _Dispute?.elements?.find((elem: any) => elem.refstr === elemtype)?.settings?.config || [];
  
    if (!statements || statements.length === 0) {
      // console.log("No statements found for element type:", elemtype);
      setStatementsReady(true); // Still mark ready
      return;
    }

    const { newContent, conditionalReports }:any = runConditionalLogic(statements, renderPkg)
    return { newContent, conditionalReports }
  };

  const prepContent = () => {
    if( !_Dispute ) return
    const statements = _Dispute?.elements?.find((elem: any) => elem.refstr === elemtype)?.settings?.config || [];
    const { newContent, conditionalReports }:any = evaluateAllStatements(statements)
    setContentToDisplay(newContent);
    setConditionalReport(conditionalReports); // ✅ One clean state update AFTER everything done
    setStatementsReady(true);
  }
  

  useEffect(() => {
    prepContent()
  },[_Dispute, elemtype, renderPkg.clientdata, renderPkg.apidata])

  const outerWrapperStyling = useRenderStyling("w-full", "styleObj")

  // if(  !statementsReady || !contentToDisplay || contentToDisplay.length === 0 ) return <></>
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>

      { elemtype === "compelling_evidence" && <SectionHeaderRender title="Supporting Evidence" className="mb-4" /> }

      <div {...outerWrapperStyling}>
        { contentToDisplay.length === 0 && (
          <p className="text-gray-500 text-sm">No statements available.</p>
        )}

        <StatementsWrapperTag elemtype={elemtype}>
          { contentToDisplay.map( ( contentObj:any, index:number) => (
            <RenderedStatementElement key={index} idx={index} elemtype={elemtype} mode={mode} contentObj={contentObj} renderPkg={renderPkg} />
          ))}
        </StatementsWrapperTag>
      </div>
    </div>
  )
}

const StatementsRender = React.memo(StatementsRenderInternal, (prevProps, nextProps) => {
  return true; // Force React to think props are identical always
});

export default StatementsRender;